var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcListCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15538_22637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15538_22637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15.8333V4.16667V13.625V11.8542V15.8333ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V10.8333H15.8333V4.16667H4.16667V15.8333H10V17.5H4.16667ZM14.4583 18.3333L11.5 15.375L12.6875 14.2083L14.4583 15.9792L18 12.4375L19.1667 13.625L14.4583 18.3333ZM6.66667 10.8333C6.90278 10.8333 7.10069 10.7535 7.26042 10.5938C7.42014 10.434 7.5 10.2361 7.5 10C7.5 9.76389 7.42014 9.56597 7.26042 9.40625C7.10069 9.24653 6.90278 9.16667 6.66667 9.16667C6.43056 9.16667 6.23264 9.24653 6.07292 9.40625C5.91319 9.56597 5.83333 9.76389 5.83333 10C5.83333 10.2361 5.91319 10.434 6.07292 10.5938C6.23264 10.7535 6.43056 10.8333 6.66667 10.8333ZM6.66667 7.5C6.90278 7.5 7.10069 7.42014 7.26042 7.26042C7.42014 7.10069 7.5 6.90278 7.5 6.66667C7.5 6.43056 7.42014 6.23264 7.26042 6.07292C7.10069 5.91319 6.90278 5.83333 6.66667 5.83333C6.43056 5.83333 6.23264 5.91319 6.07292 6.07292C5.91319 6.23264 5.83333 6.43056 5.83333 6.66667C5.83333 6.90278 5.91319 7.10069 6.07292 7.26042C6.23264 7.42014 6.43056 7.5 6.66667 7.5ZM9.16667 10.8333H14.1667V9.16667H9.16667V10.8333ZM9.16667 7.5H14.1667V5.83333H9.16667V7.5Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListCheck);
export default __webpack_public_path__ + "static/media/ic-list-check.8bc2c4840ec929f28a89590cbcbf882b.svg";
export { ForwardRef as ReactComponent };